import skeleton from './styles.module.scss';

export default function MinesGameBoardSkeleton(): JSX.Element {
  return (
    <>
      {Array.from({ length: 25 }).map((_: any, index: number) => (
        <div className={skeleton.card} key={`card-mine-skeleton-${index}`} />
      ))}
    </>
  );
}
